import React, { memo } from "react";
import { Controller } from "react-hook-form";
import RequiredTitle from "./RequiredTitle";

const TextAreaField = ({ input, control, error }) => {
  const { name, type, label, validation, alignment = {}, defaultValues, ...rest } = input;
  const { sm = 12, md = 12, lg = 12} = alignment;

  return (
    <div
      key={name}
      className={`form-group mb-3 col-sm-${sm} col-md-${md} col-lg-${lg}`}
    >
      <RequiredTitle
        label={label}
        validation={validation}
      />
      <Controller
        name={name}
        control={control}
        rules={validation}
        defaultValue={defaultValues}
        render={({ field }) => (
          <>
            <textarea
              id={name}
              {...field}
              {...rest}
              className={`form-control ${error ? "is-invalid" : ""}`}
            />
            {error && <div className="invalid-feedback">{error}</div>}
          </>
        )}
      />
    </div>
  );
};

export default memo(TextAreaField);
